import _ from 'lodash';

import ConversationMessageCompositionContent from 'models/composition/conversation_message_composition_content';
import CreateComposition from './lib/create_composition';
import { getLatestManualItem } from 'scripts/application/lib/conversation_history_helpers';
import { MessageChannelType } from 'models/conversation_message';
import { ExternalCustomerAddressType } from 'models/customer_profile/external_customer_address';

class CreateWhatsAppComposition extends CreateComposition {
  constructor(context) {
    super(context, ConversationMessageCompositionContent);
  }

  _createContent(attrs) {
    const lastWhatsAppItem = this._findLastWhatsAppItem(attrs.conversationId);

    const conversation = this.customerStores.conversations.find(attrs.conversationId);
    let companyAddress;
    let customerAddress;
    let customerDisplayName;

    if (lastWhatsAppItem) {
      companyAddress = lastWhatsAppItem.content.companyAddress;
      customerAddress = lastWhatsAppItem.content.customerAddress;
      customerDisplayName = customerAddress;
    } else {
      const whatsappAddresses = this.customerStores.profile
        .get()
        .getExternalCustomerAddressForType(ExternalCustomerAddressType.WHATSAPP);

      customerAddress = whatsappAddresses[0]?.id || '';
      customerDisplayName = whatsappAddresses[0]?.displayName || '';
    }

    const potentialFroms = this._getPotentialFroms(conversation);
    if (!_.includes(potentialFroms.allFromNumbers, companyAddress)) {
      companyAddress = potentialFroms.default;
    }

    return new ConversationMessageCompositionContent({
      channel: MessageChannelType.WHATSAPP,
      companyAddress,
      customerAddress,
      companyDisplayName: companyAddress,
      customerDisplayName,
    });
  }

  _canCreateComposition() {
    const hasOutboundConversationActions = this.context.stores.appFeatures.get().isEnabled('conversation:outbound');
    const channelConfiguration = this.context.stores.channelConfiguration.get();
    return (
      channelConfiguration && channelConfiguration.companyWhatsAppNumbers().length > 0 && hasOutboundConversationActions
    );
  }

  _getPotentialFroms(conversation) {
    let channelConfiguration = this.context.stores.channelConfiguration.get();
    let whatsAppEndpoints = channelConfiguration
      ? channelConfiguration.getEndpointsOfType(MessageChannelType.WHATSAPP)
      : [];
    let allFromNumbers = _.map(whatsAppEndpoints, 'address');
    let routingGroupId = conversation.assignee.routingGroupId;

    return this._getFroms({
      allFromNumbers,
      conversation,
      endpoints: whatsAppEndpoints,
      endpointType: MessageChannelType.WHATSAPP,
      routingGroupId,
    });
  }

  _findLastWhatsAppItem(conversationId) {
    const customerId = this.context.stores.currentLocation.get().customerId;
    const { conversationHistory } = this.context.stores.customers.storesFor(customerId);
    return getLatestManualItem({
      conversationHistory,
      filter: item => item.content.channel === MessageChannelType.WHATSAPP,
      conversationId,
    });
  }
}

export default CreateWhatsAppComposition;
